<template>
  <NavButton class="hover:bg-light-purple-nav group">
    <span
      class="flex items-center gap-2 text-light-sec-purple group-hover:text-white dark:text-light-font"
    >
      <slot />
    </span>
  </NavButton>
</template>
